export interface BookRatings {
    rating_5_stars?: number;
    rating_4_stars?: number;
    rating_3_stars?: number;
    rating_2_stars?: number;
    rating_1_star?: number;
    avg_rating?: number;
    total_ratings?: number;
  }
  
  export function calculatePositiveRatingPercentage(ratings: BookRatings): number {
    if (!ratings || !ratings.total_ratings || ratings.total_ratings === 0) return 0;
  
    if (ratings.rating_4_stars !== undefined && ratings.rating_5_stars !== undefined) {
      const positiveRatings = ratings.rating_4_stars + ratings.rating_5_stars;
      return Math.round((positiveRatings / ratings.total_ratings) * 100 );
    }
    
    return 0;
  }
  
  export function calculateRatingPercentageFromAverage(avg_rating?: number, total_ratings?: number): number {
    const maxRating = 5; // Assuming a 5-star scale
  
    if (!avg_rating || !total_ratings || total_ratings === 0) return 0;
    
    // Confidence adjustment to moderate the score for low review counts
    const confidenceAdjustment = Math.min(1, Math.sqrt(total_ratings) / 10);
    
    // Convert average rating to percentage
    const ratingPercentage = Math.round(
      (avg_rating / maxRating) * 100 * confidenceAdjustment
    );
  
    return ratingPercentage;
  }
  
  export function calculatePercentageRating(ratings: BookRatings): number {
    if (!ratings) return 0;
  
    // First try to calculate from star ratings
    const positivePercentage = calculatePositiveRatingPercentage(ratings);
    if (positivePercentage > 0) {
      return positivePercentage;
    }
    
    // If star ratings not available, calculate from average rating
    if (ratings.avg_rating && ratings.total_ratings) {
      return calculateRatingPercentageFromAverage(ratings.avg_rating, ratings.total_ratings);
    }
    
    return 0;
  }